import { render, staticRenderFns } from "./UploadFileList.vue?vue&type=template&id=5e4c8225"
import script from "./UploadFileList.vue?vue&type=script&lang=js"
export * from "./UploadFileList.vue?vue&type=script&lang=js"
import style0 from "./UploadFileList.vue?vue&type=style&index=0&id=5e4c8225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports